if (!customElements.get('product-description')) {
  customElements.define(
    'product-description',
    class ProductDescription extends HTMLElement {
      constructor() {
        super();
        this.closePopup = this.querySelector(".product__description-full-close")
      }

      connectedCallback() {
        document.addEventListener('DOMContentLoaded', () => {
          this.closePopup?.addEventListener('click', () => this.querySelector('details')?.removeAttribute('open'))
        })
      }
    }
  );
}
